var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": "",
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "520px",
      },
      on: { close: _vm.handleClose },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "90px",
            size: "mini",
          },
        },
        [
          _vm.showRestrictionFields
            ? _c(
                "el-form-item",
                { attrs: { label: "限制类型", prop: "block_type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择",
                        disabled: _vm.disableTypeValue,
                      },
                      on: { change: _vm.handleChangeType },
                      model: {
                        value: _vm.form.block_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "block_type", $$v)
                        },
                        expression: "form.block_type",
                      },
                    },
                    _vm._l(_vm.typeOptions, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showRestrictionFields
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.typeValueLabel, prop: "block_value" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: `输入${_vm.typeValueLabel}，按下回车键或点击添加`,
                      disabled: _vm.disableTypeValue,
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleAddValue.apply(null, arguments)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleAddValue },
                                },
                                [_vm._v("添加")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3159907548
                    ),
                    model: {
                      value: _vm.form.block_value,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "block_value", $$v)
                      },
                      expression: "form.block_value",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "限制方式", prop: "limit_type" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { multiple: "", placeholder: "选择限制方式" },
                  model: {
                    value: _vm.form.limit_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "limit_type", $$v)
                    },
                    expression: "form.limit_type",
                  },
                },
                _vm._l(_vm.methodOptions, function (opt) {
                  return _c("el-option", {
                    key: opt.value,
                    attrs: { label: opt.label, value: opt.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "reason" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "输入备注",
                },
                model: {
                  value: _vm.form.reason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reason", $$v)
                  },
                  expression: "form.reason",
                },
              }),
            ],
            1
          ),
          _vm.form.block_type !== 4
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "同时拉黑IP登录过的账号",
                    "label-width": "200px",
                  },
                },
                [
                  _c("el-switch", {
                    attrs: {
                      disabled: _vm.isEdit,
                      "active-text": "是",
                      "inactive-text": "否",
                      "active-value": true,
                      "inactive-value": false,
                    },
                    model: {
                      value: _vm.form.isDisableAccounts,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isDisableAccounts", $$v)
                      },
                      expression: "form.isDisableAccounts",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.blockVaueList.length > 0 && _vm.form.block_type !== 4
        ? _c(
            "div",
            { staticClass: "block-value-list" },
            [
              _c("div", { staticClass: "block-value-list-title" }, [
                _vm._v("拉黑" + _vm._s(_vm.typeValueLabel) + "列表"),
              ]),
              _vm._l(_vm.blockVaueList, function (value) {
                return _c(
                  "el-tag",
                  {
                    key: value,
                    staticStyle: {
                      "margin-right": "5px",
                      "margin-bottom": "5px",
                    },
                    attrs: { type: "danger", size: "mini", closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.handleRemoveValue(value)
                      },
                    },
                  },
                  [_vm._v(_vm._s(value))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary", loading: _vm.submitting },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }